
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M8.99985 5V5.38C8.16985 5.05 7.27985 4.88 6.38985 4.88C4.96985 4.88 3.54985 5.31 2.33985 6.17C1.82985 6.53 1.76985 7.26 2.20985 7.7L4.77985 10.27H5.88985V11.38C6.74985 12.24 7.86985 12.69 8.99985 12.74V15H6.99985C6.44985 15 5.99985 15.45 5.99985 16V18C5.99985 19.1 6.89985 20 7.99985 20H17.9998C19.6598 20 20.9998 18.66 20.9998 17V5C20.9998 4.45 20.5498 4 19.9998 4H9.99985C9.44985 4 8.99985 4.45 8.99985 5ZM7.88985 10.41V8.26H5.60985L4.56985 7.22C5.13985 7 5.75985 6.88 6.38985 6.88C7.72985 6.88 8.97985 7.4 9.92985 8.34L11.3398 9.75L11.1398 9.95C10.6298 10.46 9.94985 10.75 9.21985 10.75C8.74985 10.75 8.28985 10.63 7.88985 10.41ZM18.9998 17C18.9998 17.55 18.5498 18 17.9998 18C17.4498 18 16.9998 17.55 16.9998 17V16C16.9998 15.45 16.5498 15 15.9998 15H10.9998V12.41C11.5698 12.18 12.0998 11.84 12.5598 11.38L12.7598 11.18L15.5898 14H16.9998V12.59L10.9998 6.62V6H18.9998V17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-history-edu`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHistoryEdu

    ```js
    <b-new-b-icon-history-edu />
    ```
</docs>


